import { defineStore } from 'pinia'
import { getDataLang } from '../helpers/api'

export interface IEvents {
  event_title: string
  event_description: string
  event_image: string
  is_placeholder_image?: boolean
  book_link: string
  brochure_event_link: string | undefined
  custom_link: string
  capacity: string
  reserve_link: string
}

export interface IEventsState {
  list: IEvents[]
  loading: boolean
}

export const useEventsStore = defineStore('events', {
  state: (): IEventsState => ({
    list: [],
    loading: false,
  }),
  getters: {
    getList(): IEventsState['list'] {
      return getDataLang(this.list, 0, 'event')
    },
  },
  actions: {
    async setList(data: IEvents[]) {
      this.list = data
    },
  },
})
